export const somenteNumeros = (value) => {
  if (value) {
    return value.replace(/\D/g, "");
  }
};
